import type { LogObject } from '../types/LogObject';
import { get as getConfig } from './config';
import { LOG_ENDPOINT_DEV, LOG_ENDPOINT_LIVE } from '../constants/logger';

/**
 * Sends logs to the server.
 * @param payload
 * @param applicationUid
 */
export default function send(payload: Array<LogObject>, applicationUid: string | null = null): Promise<{ status: number; index?: number; errors?: unknown; }> {
    const useDevServer = getConfig('useDevServer', applicationUid);

    const fetchFunction = ((getConfig('fetch', applicationUid) as undefined | typeof fetch) || fetch);
    if (!fetchFunction) {
        throw new Error('could not find fetch function')
    }

    return fetchFunction(useDevServer ? LOG_ENDPOINT_DEV : LOG_ENDPOINT_LIVE, {
        method: 'POST',
        headers: {
            'X-ApplicationGuid': applicationUid ? applicationUid : (getConfig('applicationUid') as string),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    }).then(res => {
        if (res.status === 400 && res.headers.get('content-type')?.includes('application/json')) {
            return res.json().then(({ index, errors }) => ({
                status: res.status,
                index,
                errors,
            }));
        }

        return {
            status: res.status
        };
    });
}
